// extracted by mini-css-extract-plugin
export var button = "CardsSection-module--button--c5126";
export var cardItem = "CardsSection-module--cardItem--4e13b";
export var container = "CardsSection-module--container--6e2f8";
export var containerDef = "CardsSection-module--containerDef--80a4d";
export var containerOne = "CardsSection-module--containerOne--908d3";
export var desc = "CardsSection-module--desc--20947";
export var grid = "CardsSection-module--grid--fde05";
export var gridCenteredRows = "CardsSection-module--gridCenteredRows--bd823";
export var section = "CardsSection-module--section--cc79c";
export var title = "CardsSection-module--title--051ef";
export var withBg = "CardsSection-module--withBg--34e8d";